import { HrajSRozumemAnalytics } from "./utils/analytics-hraj-s-rozumem";

const registerFakeSubmitButtonClick = () => {
    const fakeSubmitButton = document.getElementById("contact-form-submit-button");

    fakeSubmitButton.addEventListener("click", () => {
        const kenticoSubmitButton = document.querySelector<HTMLButtonElement>("form input[type='submit']");
        kenticoSubmitButton.click();
    });
};

const hideButtonOnFormSubmit = () => {
    const formWrapper = document.getElementById("contact-form-kentico-wrapper");
    const config = { attributes: false, childList: true, subtree: false };

    const callback = () => {
        const form = formWrapper.querySelector("form");
        if (!form) {
            const fakeSubmitButton = document.getElementById("contact-form-submit-button");
            const formHeadline = document.getElementById("contact-form-headline");
            fakeSubmitButton.remove();
            formHeadline.remove();
            HrajSRozumemAnalytics.pushContactFormSubmit();
        }
    };

    const observer = new MutationObserver(callback);
    observer.observe(formWrapper, config);
};

export const useContactForm = () => {
    const contactform = document.getElementById("contact-form");
    if (!contactform) {
        return;
    }

    registerFakeSubmitButtonClick();
    hideButtonOnFormSubmit();
};
